// Tooltip — hover/focus popup built on Base UI's headless Tooltip primitive.
//
// Replaces the native `title=""` attribute when we need rich (multi-line /
// styled) content. Base UI gives us portal positioning, hover delay, focus
// support and outside-dismiss for free.
//
// Usage:
//   <Tooltip content={<UpstreamList .../>} >
//     <span className="badge">3 个上游</span>
//   </Tooltip>
//
// Wrap a subtree (e.g. a whole table) in <TooltipProvider> once so multiple
// tooltips share a single open-delay timer (snappier successive hovers).

import React from 'react';
import { Tooltip as BaseTooltip } from '@base-ui/react/tooltip';

const POPUP_STYLE = {
  background: 'var(--bg-1)',
  border: '1px solid var(--line-2)',
  borderRadius: 8,
  padding: '8px 10px',
  boxShadow: '0 12px 32px rgba(0,0,0,0.5)',
  fontSize: 12,
  color: 'var(--fg-1)',
  outline: 'none',
  maxWidth: 320,
};

export const TooltipProvider = ({ children, delay = 200 }) => (
  <BaseTooltip.Provider delay={delay}>{children}</BaseTooltip.Provider>
);

export const Tooltip = ({
  content,
  children,
  side = 'top',
  align = 'center',
  sideOffset = 6,
  disabled = false,
}) => {
  if (disabled || content == null) return children;
  return (
    <BaseTooltip.Root>
      <BaseTooltip.Trigger render={children} />
      <BaseTooltip.Portal>
        <BaseTooltip.Positioner
          side={side}
          align={align}
          sideOffset={sideOffset}
          style={{ zIndex: 200 }}
        >
          <BaseTooltip.Popup style={POPUP_STYLE}>
            <BaseTooltip.Arrow
              style={{ display: 'flex' }}
              render={
                <span
                  style={{
                    width: 8,
                    height: 8,
                    transform: 'rotate(45deg)',
                    background: 'var(--bg-1)',
                    borderRight: '1px solid var(--line-2)',
                    borderBottom: '1px solid var(--line-2)',
                  }}
                />
              }
            />
            {content}
          </BaseTooltip.Popup>
        </BaseTooltip.Positioner>
      </BaseTooltip.Portal>
    </BaseTooltip.Root>
  );
};
